export class PqrPersonMasterEntity{

    id:number;
    description:string;
    active:boolean;
    userId:number;
    typePqrId:number;
    
    constructor (){}
}